/**
 * Route definitions for the JobSites module.
 * Lazily loads page components for job sites list and job site details.
 */
import createFeatureRoutes from '@/common/presentation/components/MainRouteHelper/MainRouteHelper';

const JobSitesRoutes = createFeatureRoutes(
  'jobSites',
  {
    list: () => import('../presentation/pages/JobSitesPage'),
    details: () => import('../presentation/pages/JobSiteDetails')
  },
  [
    { path: '', pageKey: 'list' },
    { path: 'create', pageKey: 'details' },
    { path: ':id', pageKey: 'details' }
  ]
);

export default JobSitesRoutes;
